import React from 'react';
import { Box, Typography } from '@mui/material';

interface BrandProps {
  align?: 'left' | 'center';
  size?: 'sm' | 'md' | 'lg';
  subtitle?: string;
  color?: string;
}

export const Brand: React.FC<BrandProps> = ({ align = 'center', size = 'md', subtitle, color }) => {
  const sizes = {
    sm: { title: 'h6' as const, subtitle: 'body2' as const },
    md: { title: 'h5' as const, subtitle: 'body2' as const },
    lg: { title: 'h4' as const, subtitle: 'body1' as const },
  }[size];

  return (
    <Box sx={{ textAlign: align }}>
      <Typography variant={sizes.title} fontWeight={700} color={color || 'text.primary'}>
  DashFlow
</Typography>
{subtitle && (
  <Typography variant={sizes.subtitle} color="text.secondary" sx={{ mt: 0.5 }}>
    {subtitle}
  </Typography>
)}
    </Box>
  );
};
